import ApiService from './ApiService';

export default class AuthApi extends ApiService {
    signIn(payload) {
        return this.post('sign-in', payload);
    }

    signOut() {
        return this.post('sign-out');
    }

    getProfile() {
        return this.get('profile');
    }

    forgotPassword(payload) {
        return this.post('forgot-password', payload);
    }

    resetPassword(payload) {
        return this.post('set-password', payload);
    }

    changePassword(payload) {
        return this.post('change-password', payload);
    }

    verifyOtp(payload) {
        return this.post('verify-otp', payload);
    }

    verifyUuid(payload) {
        return this.post('verify-uuid', payload);
    }

    resendOtp(payload) {
        return this.post('resend-otp', payload);
    }
}
